import * as React from 'react';
const SvgWaveTwoMobile = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 375 145"
    fill="none"
    {...props}
  >
    <g clipPath="url(#tools_top_mob_svg__a)">
      <path
        fill="url(#tools_top_mob_svg__b)"
        d="M386.591 2840.5c-80.063-18.64-223.371-104.2-382.183-102.1-158.812 2.1-220.5 115.04-378 119.5-157.5 4.46-222.616-91.22-380.116-85.44-157.5 5.77-266.432 142.85-378.002 105.84-111.56-37.01-492.91-2639.119-112.29-2763.807 53.09 11.631 193.5 38.5 442.101 28.001 248.601-10.499 270.768-54.121 429-55.5 138.972-1.21 288.4 56.499 439.4 56.499 135.999 0 241.899-73.499 367.898-36.499"
      />
      <g clipPath="url(#tools_top_mob_svg__c)">
        <path
          fill="url(#tools_top_mob_svg__d)"
          d="M-1172 38.065c82.5 4.325 240.356 61.99 404 56.854 163.644-5.136 227.031-56.448 389.323-56.854C-216.386 37.66-151.292 83.613 11 83.478c162.292-.135 273.543-110.85 388.5-62.06C514.457 70.21 954.819 190.17 562.614 315.73 170.409 441.29-1056.25 572.527-1482.26 640.105"
          opacity={0.05}
        />
        <path
          fill="url(#tools_top_mob_svg__e)"
          d="M-1164.17 89.965c82.5 4.325 232.348 25.896 395.993 20.76 163.644-5.136 227.208-45.007 389.5-45.412 162.291-.406 227.208 43.601 389.5 43.466 162.291-.135 274.543-92.906 389.5-44.115 114.956 48.791 554.496 152.754 162.291 278.314C170.409 468.538-1056.25 599.775-1482.26 667.353"
          opacity={0.53}
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="tools_top_mob_svg__b"
        x1={-106277}
        x2={-106277}
        y1={1033.24}
        y2={-59450}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3996B3" />
      </linearGradient>
      <linearGradient
        id="tools_top_mob_svg__d"
        x1={108744}
        x2={108744}
        y1={23.237}
        y2={61710.1}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3996B3" />
      </linearGradient>
      <linearGradient
        id="tools_top_mob_svg__e"
        x1={108744}
        x2={108744}
        y1={50.484}
        y2={61737.3}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3996B3" />
      </linearGradient>
      <clipPath id="tools_top_mob_svg__a">
        <path fill="#fff" d="M375 145H0V0h375z" />
      </clipPath>
      <clipPath id="tools_top_mob_svg__c">
        <path fill="#fff" d="M-1159-241H399v519h-1558z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWaveTwoMobile;
